module.exports = __webpack_public_path__ + "static/media/480.fcc7b1c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-measurement-tool/light/480.png
// module id = 2242
// module chunks = 2